seo:
  siteTitle: Tale-Dokumentation
  ogImageAlt: Tale-Logo
nav:
  homeAriaLabel: Tale Dokumentation Startseite
  sidebarAriaLabel: Dokumentation
  groups:
    start: Start
    cloud: Cloud
    selfHosted: Selbst gehostet
    install: Installation
    configuration: Konfiguration
    operate: Betrieb
    observability: Beobachtbarkeit
    security: Sicherheit
    releaseNotes: Release Notes
    authentication: Authentifizierung
    platform: Plattform
    chat: Chat
    workspace: Arbeitsbereich
    agents: Agents
    automations: Automatisierungen
    knowledge: Wissen
    connectors: Connectors
    member: Mitglied
    editor: Bearbeiter
    developer: Entwickler
    admin: Verwaltung
    tutorials: Tutorials
    develop: Entwicklung
    projects: Projekte
    approvals: Genehmigungen
    governance: Governance
    legal: Rechtliches
    tutorialsAdmin: Verwaltung
    tutorialsEditor: Bearbeiter
    tutorialsDeveloper: Entwickler
    tutorialsMember: Mitglied
    tutorialsVideos: Videos
docs:
  home: Start
pwa:
  updateAvailableTitle: Aktualisierung verfügbar
  updateAvailableDescription: Eine neue Version der Doku ist bereit.
  updateNow: Neu laden
  updateLater: Später
  dismiss: Schließen
  offlineReady: Die Offline-Seite ist bereit.
